const MODULE_LOAD_ERROR_SIGNATURES = [
  "Failed to fetch dynamically imported module",
  "Loading chunk",
  "Loading CSS chunk",
  "is not a valid JavaScript MIME type",
  "Importing a module script failed",
];

export function isRecoverableModuleLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  if (error.name === "ChunkLoadError") {
    return true;
  }

  return MODULE_LOAD_ERROR_SIGNATURES.some((messageFragment) =>
    error.message.includes(messageFragment),
  );
}
